// Make a deep clone of object
export const clone = obj => JSON.parse(JSON.stringify(obj))

// Wrapper for setTimeout
export const defer = (duration, fn) => setTimeout(fn, duration)

// Calls an input function n times, returning an array of the results.
export const times = (n, fn) => {
  const result = []
  for (let i = 0; i < n; i++) {
    result.push(fn(i))
  }
  return result
}
